import {
  FETCHING_DATA_FOR_ACCOUNTS_MAP_MODAL,
  FETCHING_DATA_FOR_ACCOUNTS_MAP_MODAL_FINISHED,
  FETCH_ACCOUNTS_FOR_ACCOUNT_MAP,
  FETCH_ACCOUNTS_FOR_ACCOUNT_MAP_SUCCESS,
  FETCH_ACCOUNTS_FOR_ACCOUNT_MAP_FAILURE,
  IMPORTING_ACCOUNT_MAP,
  IMPORTING_ACCOUNT_MAP_SUCCESS,
  IMPORTING_ACCOUNT_MAP_FAILURE,
} from './types';

import { fetchAccounts as fetchAccountsApi } from '../../../shared/api';

import {
  importAccountMaps as importAccountMapsApi,
} from '../api';
import { fetchingError } from '../../../shared/store/actions';
import { errorNotification } from '../../../shared/store/notificationActions';

import agGridConfig from '../../../agGridConfig';
import getApi from '../../shared/apiFactory';
import getActions from '../../shared/store/actionsFactory';
import { adminPageNames, adminPageTitles } from '../../shared/adminPageNames';
import Config from '../../../config';
import { FIELD_MAPPINGS, MIN_COLUMNS_NUMBER, MAX_COLUMNS_NUMBER } from '../xlsxImport/constants';
import columnHeaders from '../xlsxImport/columnHeaders';
import { normalizeCellToString } from '../../../utils/readXlsxFile.utils';

export const sharedActions = getActions(
  adminPageNames.ACCOUNT_MAP,
  {
    pageTitle: adminPageTitles.ACCOUNT_MAP,
    api: getApi({
      pageTitle: adminPageTitles.ACCOUNT_MAP,
      endpoints: {
        FETCH: Config.endpoints.FETCH_ACCOUNT_MAP,
        INSERT: Config.endpoints.INSERT_ACCOUNT_MAP,
        UPDATE: Config.endpoints.UPDATE_ACCOUNT_MAP,
        DELETE: Config.endpoints.DELETE_ACCOUNT_MAP,
        VALIDATE: Config.endpoints.VALIDATE_ACCOUNT_MAP,
        IMPORT: Config.endpoints.IMPORT_ACCOUNT_MAP,
      },
    }),
    sortingField: 'accountMap',
    agGridConfig: agGridConfig.adminAccountMap,
    excel: {
      sheetName: 'Account Map',
      lastColumnLetter: 'C',
      columnHeaders,
      fieldMappings: FIELD_MAPPINGS,
      minColumnsNumber: MIN_COLUMNS_NUMBER,
      maxColumnsNumber: MAX_COLUMNS_NUMBER,
      fieldNormalizers: {
        period: normalizeCellToString,
        bsmaccount: normalizeCellToString,
        glaccount: normalizeCellToString,
      },
    },

  }
);

export const importAccountMap = (AccountMaps, periodName) => async dispatch => {
  dispatch({
    type: IMPORTING_ACCOUNT_MAP,
  });
  try {
    await importAccountMapsApi(AccountMaps, periodName);
    dispatch({
      type: IMPORTING_ACCOUNT_MAP_SUCCESS,
    });
  } catch (error) {
    dispatch(errorNotification(error.message));
    dispatch({
      type: IMPORTING_ACCOUNT_MAP_FAILURE,
    });
  }
};

export const fetchAccounts = () => async dispatch => {
  dispatch({
    type: FETCH_ACCOUNTS_FOR_ACCOUNT_MAP,
  });
  try {
    const response = await fetchAccountsApi();

    return dispatch({
      type: FETCH_ACCOUNTS_FOR_ACCOUNT_MAP_SUCCESS,
      accounts: response,
    });
  } catch (error) {
    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return dispatch({
        type: FETCH_ACCOUNTS_FOR_ACCOUNT_MAP_FAILURE,
      });
    }
    throw error;
  }
};

export const fetchInitialDataForAccountMapAddEditModal = () => async dispatch => {
  dispatch({
    type: FETCHING_DATA_FOR_ACCOUNTS_MAP_MODAL,
  });

  await dispatch(fetchAccounts());

  dispatch({
    type: FETCHING_DATA_FOR_ACCOUNTS_MAP_MODAL_FINISHED,
  });
};
